import { api } from '@/lib/api/api'
import {
  BusinessProfileDeleteResponse,
  BusinessProfileListResponse,
  BusinessProfileResponse,
  CreateBusinessProfileRequest,
  UpdateBusinessProfileRequest,
} from './types'

export const businessProfileApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get all business profiles for the user's workspace
    getBusinessProfiles: builder.query<BusinessProfileListResponse, void>({
      query: () => 'v2/business-profiles',
      providesTags: ['BusinessProfile'],
    }),

    // Get user's default business profile
    getDefaultBusinessProfile: builder.query<BusinessProfileResponse, void>({
      query: () => 'v2/business-profiles/default',
      providesTags: ['BusinessProfile'],
    }),

    // Get a specific business profile by ID
    getBusinessProfile: builder.query<BusinessProfileResponse, string>({
      query: (id) => `v2/business-profiles/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'BusinessProfile', id }],
    }),

    // Create a new business profile
    createBusinessProfile: builder.mutation<BusinessProfileResponse, CreateBusinessProfileRequest>({
      query: (body) => ({
        url: 'v2/business-profiles',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BusinessProfile'],
    }),

    // Update an existing business profile
    updateBusinessProfile: builder.mutation<
      BusinessProfileResponse,
      { id: string; data: UpdateBusinessProfileRequest }
    >({
      query: ({ id, data }) => ({
        url: `v2/business-profiles/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        'BusinessProfile',
        { type: 'BusinessProfile', id },
      ],
    }),

    // Set a business profile as default
    setDefaultBusinessProfile: builder.mutation<BusinessProfileResponse, string>({
      query: (id) => ({
        url: `v2/business-profiles/${id}/set-default`,
        method: 'POST',
      }),
      invalidatesTags: ['BusinessProfile'],
    }),

    // Delete a business profile
    deleteBusinessProfile: builder.mutation<BusinessProfileDeleteResponse, string>({
      query: (id) => ({
        url: `v2/business-profiles/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BusinessProfile'],
    }),
  }),
})

export const {
  useGetBusinessProfilesQuery,
  useGetDefaultBusinessProfileQuery,
  useGetBusinessProfileQuery,
  useCreateBusinessProfileMutation,
  useUpdateBusinessProfileMutation,
  useSetDefaultBusinessProfileMutation,
  useDeleteBusinessProfileMutation,
} = businessProfileApi
